/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butberechtigungdurch4Inputs */

const de__field_butberechtigungdurch4 = /** @type {(inputs: _Field_Butberechtigungdurch4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Berechtigung durch`)
};

/**

* @param {_Field_Butberechtigungdurch4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butberechtigungdurch4 = /** @type {((inputs?: _Field_Butberechtigungdurch4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butberechtigungdurch4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butberechtigungdurch4(inputs)
});
export { _field_butberechtigungdurch4 as "_field_BuTBerechtigungDurch" }